<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-02 19:29:11
 * @LastEditors: yd
 * @LastEditTime: 2020-10-21 15:51:26
--> 
<template>
  <div>
    <timedTask></timedTask>
  </div>
</template> 

<script>
// import { addemailtemplate } from '@/service/api/emailtemplate'
import timedTask from './modules/timedTask'
export default {
  components: {
    timedTask
  },
  data () {
    return {
    }
  },
  mounted () {

  },
  methods: {
  }
}
</script>